import { useState } from "react";

type ImageLazyProps = {
    image: string;
    name: string;
    type?: string;
    classImage?: string;
}

export function ImageLazy({image, name, type, classImage}:ImageLazyProps){
    const [loadingImage, setLoadingImage] = useState(true);
    switch(type){
        case 'food':
            return (
                <>
                    {loadingImage && (
                        <div style={{width: 72, height: 72, backgroundColor: '#F5F5F5', borderRadius: '100%'}} />
                    )}
                    <img
                        style={loadingImage ? {width: 0, height: 0} : {}}
                        src={image}
                        alt={name}
                        className={classImage ? classImage : ''}
                        onLoad={() => setLoadingImage(false)}
                    />
                </>
            )
        default:
            return (
                <>
                    {loadingImage && (
                        <div className="no-image" />
                    )}
                    <img
                        style={loadingImage ? {width: 0, height: 0} : {}}
                        src={image}
                        alt={name}
                        onLoad={() => setLoadingImage(false)}
                    />
                </>
            )
    }
}